import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'

// Re-export from centralized styles for backwards compatibility
export {
  // Typography
  headerStyle,
  detailHeaderStyle,
  detailTextStyle,
  textStyle as textStyles,
  overlayTextStyle as overlayTextStyles,
  // Containers
  boxContainerStyles,
  alertBoxStyles as boxStyles,
  gridContainerStyles,
  gridToolbarContainerStyles,
  buttonContainerStyles,
  popoverStyles,
  dialogContentWrapperStyles as dialogContentStyles,
  gridStyles,
  filterPanelProps,
  // TextFields
  FormTextField as OrganizationTextField,
  // Buttons
  HeaderButton,
  deleteButtonStyles,
  // Info sections
  InfoBox,
  InfoRow,
  InfoLabel,
  InfoValueWrapper,
  InfoValue,
  StyledLinkBlue as StyledLink,
  Underline,
  CityStateZipRow,
  DetailsCard as OrganizationsCard,
  DetailsBox as OrgDetailsBox,
  CompanyLabelChip,
  iconValidatedStyles,
  iconInvalidatedStyles,
} from 'styles/utilities'

// Organizations-specific styled components
export const PhoneRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
  position: 'relative',
}))

export const dataGridStyles = {}

/**
 * Dialog styles for Organizations
 */
export const dialogStyles = (theme: { palette: { mode: string } }) => ({
  width: '100%',
  maxWidth: '800px',
  backgroundColor: theme.palette.mode === 'dark' ? '' : 'rgb(236, 239, 248)',
  color: 'text.primary',
  minHeight: '50vh',
  maxHeight: '95vh',
  padding: '30px',
  '& .MuiDialogContent-root': {
    width: '100%',
    padding: '20px',
  },
  '& .MuiTextField-root': {
    margin: '0px 2px 3px 5px 5px',
    minWidth: '150px',
  },
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(79, 84, 94)' : 'white',
    minWidth: '150px',
    flex: '1 1 45%',
  },
  '& .MuiSelect-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgb(79, 84, 94)' : 'white',
    flex: '1 1 45%',
    minWidth: '150px',
  },
})

/**
 * String to avatar initials helper
 */
export const stringAvatar = (name: string) => {
  const nameParts = name.split(' ')
  if (nameParts.length < 2) {
    return {
      children: (
        <Typography
          sx={{
            fontSize: 14,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          {nameParts[0][0]}
        </Typography>
      ),
    }
  }

  return {
    children: (
      <Typography
        sx={{
          fontSize: 14,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        {`${nameParts[0][0]}${nameParts[1][0]}`}
      </Typography>
    ),
  }
}
